var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConvoMenuIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3126 10.3624V6.15945C14.3126 5.61204 14.0952 5.08706 13.7081 4.69999C13.321 4.31292 12.796 4.09546 12.2486 4.09546H3.9927C3.44529 4.09546 2.92031 4.31292 2.53324 4.69999C2.14617 5.08706 1.92871 5.61204 1.92871 6.15945V11.6634C1.92871 12.2108 2.14617 12.7357 2.53324 13.1228C2.92031 13.5099 3.44529 13.7273 3.9927 13.7273H5.36868V15.7913L8.47365 13.7273H10.4598",
    stroke: "#585858",
    strokeWidth: 0.88563,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.36865 7.5354H10.8726M5.36865 10.2874H8.77883",
    stroke: "#585858",
    strokeWidth: 1.15132,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8475 10.5027C11.4981 10.5027 11.1629 10.6268 10.9158 10.8477C10.6687 11.0686 10.5298 11.3682 10.5298 11.6805V14.8214C10.5298 15.1338 10.6687 15.4334 10.9158 15.6543C11.1629 15.8752 11.4981 15.9993 11.8475 15.9993H13.6784L15.8746 17.1771V15.9993H16.753C17.1025 15.9993 17.4376 15.8752 17.6848 15.6543C17.9319 15.4334 18.0707 15.1338 18.0707 14.8214V11.6805C18.0707 11.3681 17.9319 11.0686 17.6848 10.8477C17.4376 10.6268 17.1025 10.5027 16.753 10.5027H11.8475Z",
    stroke: "#585858",
    strokeWidth: 0.802951,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8749 12.3689H12.3611M15.8749 14.1258H13.2395",
    stroke: "#585858",
    strokeWidth: 0.802951,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConvoMenuIcon);
export default __webpack_public_path__ + "static/media/convo-menu-icon.5f93a1fa4d79bdd37cf9636452d79ddf.svg";
export { ForwardRef as ReactComponent };